// extracted by mini-css-extract-plugin
export default {"input":"scale_input__omjp9","input__label":"scale_input__label__6MEGr","input__name":"scale_input__name__iPttR"};